import React from 'react'
import { ItemCardProps } from '../../interfaces'
import styles from './styles.module.scss'

export const ItemCard: React.FC<ItemCardProps> = ({ item, onView, onDownload, onDelete }) => {
    const getSourceLabel = (source: string) => {
        switch (source) {
            case 'supreme-court':
                return 'Supreme Court'
            case 'financial-ombudsman':
                return 'Financial Ombudsman'
            default:
                return source
        }
    }

    return (
        <div className={styles.itemCard}>
            <p className={styles.createdAt}>{item.createdAt.split('T')[0]}</p>
            <div className={styles.itemHeader}>
                <h4>{item.title}</h4>
                <div className={styles.headerTags}>
                    <span className={`${styles.sourceTag} ${styles[item.source]}`}>{getSourceLabel(item.source)}</span>
                    <span className={`${styles.typeTag} ${styles[item.type]}`}>{item.type}</span>
                </div>
            </div>

            <div className={styles.itemActions}>
                <button onClick={() => onView(item)} className={styles.viewBtn}>
                    View
                </button>
                <button onClick={() => onDownload(item)} className={styles.downloadBtn}>
                    Download
                </button>
                <button onClick={() => onDelete(item.id)} className={styles.deleteBtn}>
                    Delete
                </button>
            </div>
        </div>
    )
}
